/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Paper, Stack, TextField, Button } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useState, useContext, } from "react";

import { useAppBarHeight } from '../../../common/CustomHooks';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import BarChartResultReport from '../components/BarChartResultReport';
import { DatePicker } from '@mui/x-date-pickers';
import TableResult from '../components/TableResult';
import { UserContext } from '../../../layouts/AuthorizedLayout';

interface IHeader {
    generateForYear: (year: Date) => void,
}

const ReportsResultsRoute = (): JSX.Element => {

    const theme = useTheme();

    const { t } = useTranslation();

    const user = useContext(UserContext);

    //##########################################################################################################

    const [yearGenerate, setYearGenerate] = useState<Date | null>(new Date());

    function generateForYear(year: Date) {
        setYearGenerate(year);
    }

    const RenderHeader = (props: IHeader): JSX.Element => {

        const [year, setYear] = useState<Date | null>(new Date());
        const [reportDate, setReportDate] = useState<Date | null>(new Date());

        return <Grid container justifyContent="space-between">
            <Grid padding={theme.spacing(4)}>
                <Stack direction="row" spacing={theme.spacing(2)}>
                    <DatePicker
                        views={["year"]}
                        label={t("dateSearch.chooseYear")}
                        value={year}
                        onChange={(newValue) => { setYear(newValue) }}
                        slotProps={{ textField: { size: "small", helperText: null, } }}
                    />
                    <Button
                        onClick={() => year ? props.generateForYear(year) : undefined}
                        size="small"
                        sx={{ width: "6rem" }} variant="contained"
                        color="secondary">
                        {t("reports.generate")}
                    </Button>
                </Stack>
            </Grid>
            <Grid display={user?.user?.modules?.find(n => n === "AccountingSettings") ? "block" : "none"} padding={theme.spacing(4)}>
                <Stack direction="row" spacing={theme.spacing(2)}>
                    <DatePicker
                        label={t("reports.reportDate")}
                        value={reportDate}
                        onChange={(newValue) => { setReportDate(newValue) }}
                        slotProps={{ textField: { size: "small", helperText: null, } }}
                    />
                    <Button size="small" sx={{ width: "6rem" }} variant="contained" color="secondary">Set</Button>
                </Stack>
            </Grid>
        </Grid>
    }

    const appBarHeight = useAppBarHeight();
    //########################################################################################
    //########################################################################################
    return <main>
        <Grid container component={Paper} direction="column" wrap="nowrap"
            sx={{
                paddingTop: theme.spacing(2),
                width: "100%",
                height: {
                    xs: "calc(100vh - " + appBarHeight + "px )",
                    xl: "calc(100vh)"
                },
                //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
            }}>
            {/*<Grid container spacing={2} padding={theme.spacing(2)}>*/}

            {/*</Grid>*/}
            <RenderHeader generateForYear={generateForYear} />
            <Grid container minHeight="14rem">
                <BarChartResultReport year={yearGenerate ? yearGenerate : new Date()} />
            </Grid>
            <Grid container minHeight="27rem" paddingTop={theme.spacing(4)} overflow="hidden">
                <TableResult year={yearGenerate?.getFullYear()} />
            </Grid>
        </Grid>
    </main>

}
export default ReportsResultsRoute;